import { FC } from 'react'

const CartesBancairesIcon: FC = () => (
  <svg
    width="40"
    height="26"
    viewBox="0 0 40 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      y="0.5"
      width="40"
      height="25"
      rx="5"
      fill="#016797"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.8457 7.30761V12.6413H29.3587C30.066 12.6413 30.7443 12.3603 31.2444 11.8602C31.7446 11.3601 32.0255 10.6817 32.0255 9.97445C32.0255 9.26716 31.7446 8.58884 31.2444 8.08871C30.7443 7.58858 30.066 7.30761 29.3587 7.30761H20.8457ZM20.1189 12.6413C20.0709 11.5923 19.8092 10.6507 19.3681 9.85193C18.8837 8.96952 18.1577 8.24353 17.2753 7.75912C16.3869 7.26903 15.3212 7 14.1272 7H13C11.806 7 10.7414 7.26903 9.85297 7.75912C8.97056 8.24353 8.24457 8.96952 7.76017 9.85193C7.26903 10.7414 7 11.806 7 13C7 14.194 7.26903 15.2586 7.76017 16.1481C8.24401 17.0302 8.96924 17.7562 9.85089 18.2409C10.7393 18.731 11.804 19 12.9979 19H14.1262C15.3201 19 16.3858 18.732 17.2742 18.2409C18.1567 17.7565 18.8826 17.0305 19.367 16.1481C19.8081 15.3493 20.0699 14.4077 20.1178 13.3587H13.7675V12.6413H20.1189ZM20.8457 13.3587V18.6924H29.3587C30.066 18.6924 30.7443 18.4114 31.2444 17.9113C31.7446 17.4112 32.0255 16.7328 32.0255 16.0255C32.0255 15.3183 31.7446 14.6399 31.2444 14.1398C30.7443 13.6397 30.066 13.3587 29.3587 13.3587H20.8457Z"
      fill="white"
    />
  </svg>
)

export default CartesBancairesIcon
